export default "__VITE_ASSET__ClE54PRT__"